/*
 * FileName : index.tsx
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-09-09 09:55:12
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

// eslint-disable-next-line no-use-before-define
import React, { useImperativeHandle } from 'react';
import { message, Modal, Tabs, Spin } from 'antd';
// import { Key } from 'rc-tree/es/interface';
// import { LangMessage } from 'src/store/common/language';
import TerminalContent, { ItemType, DataItem } from './content';
import {
    MeterScheduleInfoData,
    QueryLastTenEventParam,
    DCUAmiData,
    DCUBaseData,
    DCULogData,
    MeterBaseInfoData,
    MeterAMIInfoData,
} from 'src/api/common/type';
import { QueryTopologyByMeterData } from 'src/api/AmiFunction/netWorkMgnt/type';
import { ColumnsType } from 'antd/es/table';
import useFetchState from 'src/utils/useFetchState';
import { common, amiFunc } from 'src/api';
import { useSelector } from 'react-redux';
import { DcuAlarmEvent } from 'src/api/collectReport/dcuAlarmEvent/types';
import { ColumnType } from 'antd/es/table';
import {NETWORK_MODEL_OPT} from 'src/utils/const';
const { TabPane } = Tabs;

type DeviceType = 'meter' | 'dcu';
export type KeyType = 'dcuGuid' | 'dcuName' | 'dcuAddress' | 'dcuNo';

export interface CRef {
    openModel(type: DeviceType, id: string, keyType?:KeyType): Promise<void>;
    closeModel(): void;
}

type Props = {
    cRef: React.MutableRefObject<CRef | undefined>;
    width?: number;
};

type TabsListItemData = DataItem[] | MeterScheduleInfoData[];

type TabsListItem<T> = {
    name: string;
    key: string;
    type: ItemType;
    data: T[];
    colunms: ColumnsType<T>;
};

const KEY_TYPE = {
    dcuGuid: 'deviceGuid',
    dcuName: 'deviceName',
    dcuAddress: 'deviceAddress',
    dcuNo: 'deviceNo',
};

// DCU AMI展示数据
// const AMITYPE = {
//     'Communication Address': 'CST_ADDR',
//     'Security level': 'SECURITY_LEVEL',
//     'Client Address': 'ClientAddr',
//     'Meter Password': 'MeterPwd',
//     'Whether to encrypt data': 'EncryptedData',
//     'Safety rules': 'SecurityPolicy',
//     'Client System Name': 'ClientTitle',
//     'Master key': 'MKey',
//     'Authentication key': 'AKey',
//     'Encrypted key': 'EKey',
//     'Broadcast E-key': 'BKey',
//     'Dedicated key': 'DKey',
//     'Private key': 'PSK',
// };

const TerminalInfo: React.FC<Props> = (props) => {
    const { cRef, width = 1000 } = props;
    const [ tabsList, setTabsList ] = useFetchState<TabsListItem<TabsListItemData>[]>([]);

    const [ visible, setVisible ] = useFetchState<boolean>(false);
    const [ devicedType, setDevicedType ] = useFetchState<DeviceType>('meter');
    const [ loading, setLoading ] = useFetchState<boolean>(true);
    const Mes = useSelector((state: any) => state.langSwitch.message);

    const deviceTitle = {
        meter: Mes['titleLabelMetermeter'],
        dcu: Mes['labelTitleGateway'],
    };

    const phaseOpt = [
        {
            value: '0',
            name: Mes['titleTableUnknownunknown'],
        },
        {
            value: '1',
            name: Mes['titlePhaseA'],
        },
        {
            value: '2',
            name: Mes['titlePhaseB'],
        },
        {
            value: '3',
            name: Mes['titlePhaseA&B'],
        },
        {
            value: '4',
            name: Mes['titlePhaseC'],
        },
        {
            value: '5',
            name: Mes['titlePhaseA&C'],
        },
        {
            value: '6',
            name: Mes['titlePhaseB&C'],
        },
        {
            value: '7',
            name: Mes['titlePhaseA&B&C'],
        },
    ];

    // tab标签列表
    const TABLIST = [
        {
            name: Mes['tabTitleInBaseInfo'],
            key: '0',
            type: 'List' as ItemType,
            data: [] as any,
            colunms: [] as any,
        },
        {
            name: Mes['tabTitleSchedule'],
            key: '1',
            type: 'Table' as ItemType,
            data: [] as any,
            colunms: [] as any,
        },
        {
            name: Mes['titleTabParameterparameter'],
            key: '2',
            type: 'List' as ItemType,
            data: [] as any,
            colunms: [] as any,
        },
    ];

    const terminalData = {
        meter: {
            tabsList: [
                ...TABLIST,
                {
                    name: Mes['titleTableGridnetworkgridnetwork'],
                    key: '3',
                    type: 'List' as ItemType,
                    data: [] as any,
                    colunms: [] as any,
                },
                {
                    name: Mes['titleAlarm&EventStatistics'],
                    key: '4',
                    type: 'Table' as ItemType,
                    data: [] as any,
                    colunms: [] as any,
                },
            ],
        },
        dcu: {
            tabsList: [
                ...TABLIST,
                {
                    name: Mes['titleTableLoginfologinfo'],
                    key: '3',
                    type: 'Table' as ItemType,
                    data: [] as any,
                    colunms: [] as any,
                },
                {
                    name: Mes['titleAlarm&EventStatistics'],
                    key: '4',
                    type: 'Table' as ItemType,
                    data: [] as any,
                    colunms: [] as any,
                },
            ],
        },
    };

    const EVENT_COLUMNS: ColumnType<DcuAlarmEvent>[] = [
        {
            title: Mes['titleTableDevicenodeviceno'],
            dataIndex: 'SN_DEVICE',
            width: 120,
            ellipsis: true,
            render (value: string, record: DcuAlarmEvent) {
                let val = record.METER_NO || '';

                if (!val) {
                    val = record.CST_NO;
                }
                return val;
            },
        },
        {
            title: Mes['titleTableUpgradestatusupgradestatus'],
            dataIndex: 'STATUS_DESC',
            width: 100,
            ellipsis: true,
            render (_: any, record: DcuAlarmEvent) {
                return (
                    <>
                        <span>{ record.STATUS === '1' ? Mes['comboboxConfirmedconfirmed'] : Mes['comboboxUnconfirmedunconfirmed']}</span>
                    </>
                );
            },
        },
        {
            title: Mes['titleTableOccurtimeoccurtime'],
            dataIndex: 'OCCUR_DATETIME',
            width: 180,
            ellipsis: true,
        },
        {
            title: Mes['titleTableRegistertimeregistertime'],
            dataIndex: 'CREATE_DATETIME',
            width: 180,
            ellipsis: true,
        },
        {
            title: Mes['titleTableEventcontenteventcontent'],
            dataIndex: 'EVENT_DESC',
            width: 200,
            ellipsis: true,
        },
        {
            title: Mes['titleTableExtendcontentextendcontent'],
            dataIndex: 'EVENT_CONTENT',
        },
    ];

    // dcu Schedule处理
    const DCUSCHEDULECOLUNMS = [
        {
            title: Mes['titleTableRemarkremark'],
            dataIndex: 'REMARK',
        },
        {
            title: Mes['titleTableAfnafn'],
            dataIndex: 'AFN',
        },
        {
            title: Mes['titleTableFnfn'],
            dataIndex: 'FN',
        },
        {
            title: Mes['titleTableAfnnameafnname'],
            dataIndex: 'AFN_NAME',
        },
        {
            title: Mes['titleLabelReadmodereadmode'],
            dataIndex: 'READ_MODE',
        },
        {
            title: Mes['titleTableParametersparameters'],
            dataIndex: 'EXTRA_PARAMETERS',
        },
    ];

    // meter Schedule处理
    const METERSCHEDULECOLUNMS = [
        {
            title: Mes['titleTableRemarkremark'],
            dataIndex: 'Remark',
        },
        {
            title: Mes['titleTableAfnafn'],
            dataIndex: 'AFN',
        },
        {
            title: Mes['titleTableFnfn'],
            dataIndex: 'FN',
        },
        {
            title: Mes['titleTableAfnnameafnname'],
            dataIndex: 'AFN_NAME',
        },
        {
            title: Mes['titleLabelReadmodereadmode'],
            dataIndex: 'READ_MODE',
            render (val: string) {
                const type = parseInt(val, 10);

                if (!type) {
                    return 'Month';
                } else if (type === 1) {
                    return 'Day';
                } else {
                    return type;
                }
            },
        },
        {
            title: Mes['titleTableParametersparameters'],
            dataIndex: 'Parameters',
        },
    ];

    // DCU log展示数据
    const LOGCOLUNMS = [
        {
            title: Mes['titleTableNono'],
            dataIndex: 'cst_no',
        },
        {
            title: Mes['titleTableIpip'],
            dataIndex: 'cst_ip',
        },
        {
            title: Mes['titleTableUpgradestatusupgradestatus'],
            dataIndex: 'cst_status',
            render (text: string) {
                if (parseInt(text, 10) === 1) {
                    return Mes['titleTableStatusonlinestatusonline'];
                } else {
                    return Mes['titleTableStatusofflinestatusoffline'];
                }
            },
        },
        {
            title: Mes['titleTableStatustimestatustime'],
            dataIndex: 'status_time',
        },
    ];

    // DCU INFO展示数据
    const DCUINFO = {
        CST_NAME: Mes['titleTableDcunamedcuname'],
        CST_TYPE_NAME: Mes['titleTableDcutypedcutype'],
        MTR_NUM: Mes['titleLableMaxLoadMeterNum'],
        CST_IP: Mes['titleTableDcuipdcuip'],
        DST_NAME: Mes['titleTableTransformernametransformername'],
        SECTION_NAME: Mes['titleTableSectionsection'],
        LONGITUDE: Mes['titleLabelLongitude'],
        LATITUDE: Mes['titleLabelLatitude'],
        CST_ARCHIVE_MODE: Mes['labelTitleArchivesMode'],
        NODE_NAME: Mes['titleTableStationnamestationname'],
        INSTORE_TIME: Mes['deviceInfoMeterInstoretimeinstoretime'],
        CST_CREATE_TIME: Mes['deviceInfoDcuCstcreatetimecstcreatetime'],
        CST_ADDR: Mes['titleTableDcuaddrdcuaddr'],
        CST_NO: Mes['titleTableDcunodcuno'],
        CST_RMK: Mes['deviceInfoDcuCstremarkcstremark'],
        CST_TOTAL_COUNT: Mes['deviceInfoDcuCsttotalcountcsttotalcount'],
        CST_REGISTERED_COUNT: Mes['deviceInfoDcuCstregisteredcountcstregisteredcount'],
        NETWORK_MODR: Mes['labelTitleCommunicationtype'],
        CELLID: Mes['labelTitleCelllD'],
        CCID: Mes['labelTitleCCID'],
        IMEI: Mes['titleTableImeiimei'],
    };

    const DCU_ARCHIVE_MODE = [
        {
            label: Mes['labelTitleRoam'],
            value: '1',
        },
        {
            label: Mes['labelTitleWhiteList'],
            value: '2',
        },
    ];

    // Meter INFO展示数据
    const METERINFO = {
        MEASURE_POINT_NO: Mes['titleTableCeliangdianhaoceliangdianhao'],
        CUSTOMER_NO: Mes['titleTableGridcustomernogridcustomerno'],
        CST_NAME: Mes['titleTableDcunamedcuname'],
        DST_NAME: Mes['titleTableTransformernametransformername'],
        LONGITUDE: Mes['titleLabelLongitude'],
        LATITUDE: Mes['titleLabelLatitude'],
        SECTION_NAME: Mes['titleTableSectionsection'],
        NODE_NAME: Mes['titleTableStationnamestationname'],
        INSTORE_TIME: Mes['deviceInfoMeterInstoretimeinstoretime'],
        FAC_NAME: Mes['deviceInfoMeterFacnamefacname'],
        METER_NO: Mes['titleTableMeternometerno'],
        ASSET_NO: Mes['labelTitleAssetNo'],
        METER_MODEL_NAME: Mes['deviceInfoMeterMetermodelnamemetermodelname'],
        BARCODE: Mes['titleTableMetertypemetertype'],
    };

    const NETWORK_TAB = {
        meterNo: Mes['titleTableMeternometerno'],
        meterAddress: Mes['titleTableMeteraddrmeteraddr'],
        parentMeterNo: Mes['labelTitleParentMeterNo'],
        rank: Mes['labelTitleRank'],
        // signalStrength: Mes['labelTitleRSSIPriority'],
        phase: Mes['titleLabelPhasephase'],
        createTime: Mes['titleTableCreatetimecreatetime'],
        lastSeen: Mes['labelTitleLastSeen'],
        status: Mes['titleTableUpgradestatusupgradestatus'],
    };

    const getMeterInfoData = async (type: DeviceType, id: string): Promise<void> => {
        const list = terminalData[type].tabsList;
        const eventParam:QueryLastTenEventParam = {
            eventType: '0',
            deviceNo: id,
        };
        // eslint-disable-next-line max-len
        const res = await Promise.allSettled([ common.getMeterBaseInfo({ METERNO: id }), common.getMeterScheduleInfo({ METERNO: id }), common.getMeterAMIInfo({ METERNO: id }), amiFunc.netWorkMgnt.getTopologyByMeter(id), common.getLastTenEvent(eventParam) ]);

        res.forEach((v, i) => {
            try {
                switch (i) {
                    case 0:
                        list[0].data = [];
                        if (v.status === 'fulfilled') {
                            // 基础数据处理
                            const baseInfoObj = (v.value as MeterBaseInfoData[])?.[0] || {};

                            list[0].data = Object.keys(METERINFO).map((key: string) => ({
                                label: METERINFO[key],
                                value: baseInfoObj?.[key] || '',
                            }));
                        } else {
                            message.error(typeof v.reason === 'string' ? v.reason : Mes['messageErrorSavefailuresavefailure']);
                        }
                        break;
                    case 1:
                        list[1].colunms = METERSCHEDULECOLUNMS;
                        list[1].data = [];
                        if (v.status === 'fulfilled') {
                            list[1].data = (v.value as MeterScheduleInfoData[])?.map((item, index) => ({ ...item, key: index }));
                        } else {
                            message.error(typeof v.reason === 'string' ? v.reason : Mes['messageErrorSavefailuresavefailure']);
                        }
                        break;
                    case 2:
                        list[2].data = [];
                        if (v.status === 'fulfilled') {
                            const result = v.value as MeterAMIInfoData;
                            // parameter数据处理
                            const dataList = result?.dataList?.[0] || [];
                            const titleList = result?.titleList;

                            list[2].data = titleList?.map((item, index) => {
                                let value = typeof dataList?.[index] === 'undefined' || dataList?.[index] === null ? '' : dataList?.[index];

                                if (item.ENUM_LIST) {
                                    const enumList = item.ENUM_LIST?.split('@')?.map((it) => {
                                        const obj = it.split(',');

                                        return {
                                            value: obj[1],
                                            name: obj[0],
                                        };
                                    });

                                    const filed = enumList.find((s) => s.value === value.toString());

                                    if (filed) {
                                        value = filed.name;
                                    }
                                }
                                return {
                                    label: item.PROTOCAL_NAME,
                                    value: value,
                                };
                            });
                        } else {
                            message.error(typeof v.reason === 'string' ? v.reason : Mes['messageErrorSavefailuresavefailure']);
                        }
                        break;
                    case 3:
                        list[3].data = [];
                        if (v.status === 'fulfilled') {
                            const result = v.value as QueryTopologyByMeterData;

                            list[3].data = Object.keys(NETWORK_TAB).map((key: string) => {
                                let obj: any = {
                                    label: NETWORK_TAB[key],
                                    value: result[key],
                                    key,
                                };

                                if (key === 'phase') {
                                    const item = phaseOpt.find((it) => it.value === result[key]);

                                    if (item) {
                                        obj.value = item.name;
                                    } else {
                                        obj.value = '-';
                                    }
                                }
                                return obj;
                            });
                        } else {
                            message.error(typeof v.reason === 'string' ? v.reason : Mes['messageErrorSavefailuresavefailure']);
                        }
                        break;
                    case 4:
                        list[4].colunms = EVENT_COLUMNS;
                        list[4].data = [];
                        if (v.status === 'fulfilled') {
                            list[4].data = (v.value as DcuAlarmEvent[])?.map((item) => ({ ...item, key: item.rn__ }));
                        } else {
                            message.error(typeof v.reason === 'string' ? v.reason : Mes['messageErrorSavefailuresavefailure']);
                        }
                        break;
                    default:
                        console.info('end');
                        break;
                }
            } catch (error) {
                console.error(error);
                message.error(Mes['messageErrorSavefailuresavefailure']);
            }
        });

        setTabsList(list);
    };

    const getDcuInfoData = async (type: DeviceType, id: string, keyType: KeyType = 'dcuGuid') => {
        // 拿到tab
        const list = terminalData[type].tabsList;
        let obj: any = {};

        obj[keyType] = id;
        const eventParam:QueryLastTenEventParam = {
            eventType: '1',
        };

        eventParam[KEY_TYPE[keyType]] = id;
        const res = await Promise.allSettled([ common.getDcuBaseData(obj), common.getDcuSchedule(obj), common.getDcuAmi(obj), common.getDcuLog(obj), common.getLastTenEvent(eventParam) ]);

        res.forEach((v, i) => {
            try {
                switch (i) {
                    case 0:
                        list[0].data = [];
                        if (v.status === 'fulfilled') {
                            list[0].data = Object.keys(DCUINFO).map((key: string) => {
                                let val = (v.value as DCUBaseData[])?.[0]?.[key];

                                if (key === 'NETWORK_MODR') {
                                    const item = NETWORK_MODEL_OPT.find((it) => it.value === val);

                                    val = item?.name || '';
                                }
                                if (key === 'CST_ARCHIVE_MODE') {
                                    const item = DCU_ARCHIVE_MODE.find((it) => it.value === val?.toString());

                                    val = item?.label || '';
                                }
                                return {
                                    label: DCUINFO[key],
                                    value: val,
                                };
                            });
                        } else {
                            message.error(typeof v.reason === 'string' ? v.reason : Mes['messageErrorSavefailuresavefailure']);
                        }
                        break;
                    case 1:
                        list[1].colunms = DCUSCHEDULECOLUNMS;
                        list[1].data = [];
                        if (v.status === 'fulfilled') {
                            list[1].data = (v.value as MeterScheduleInfoData[])?.map((item, index) => ({ ...item, key: index }));
                        } else {
                            message.error(typeof v.reason === 'string' ? v.reason : Mes['messageErrorSavefailuresavefailure']);
                        }
                        break;
                    case 2:
                        list[2].data = [];
                        if (v.status === 'fulfilled') {
                            list[2].data = (v.value as DCUAmiData)?.titleList?.map((item) => {
                                let tmpValue = (v.value as DCUAmiData)?.dataList?.[0]?.[item?.tableKey || ''] + '';

                                // eslint-disable-next-line no-constant-condition
                                if (!tmpValue || tmpValue === 'undefined') {
                                    return;
                                }

                                if (item?.ENUM_LIST && item?.ENUM_LIST?.length > 0 && item?.ENUM_LIST?.includes('@')) {
                                    let values = item?.ENUM_LIST?.split('@');

                                    for (let j = 0; j < values.length; j++) {
                                        let tmp = values?.[j]?.split(',');

                                        if (tmp[1] === tmpValue) {
                                            return {
                                                label: item.PROTOCAL_NAME,
                                                value: tmp[0],
                                            };
                                        }
                                    }
                                    return {
                                        label: item.PROTOCAL_NAME,
                                        value: tmpValue,
                                    };
                                } else {
                                    return {
                                        label: item.PROTOCAL_NAME,
                                        value: tmpValue,
                                    };
                                }
                            }).filter((item) => item);
                        } else {
                            message.error(typeof v.reason === 'string' ? v.reason : Mes['messageErrorSavefailuresavefailure']);
                        }
                        break;
                    case 3:
                        list[3].colunms = LOGCOLUNMS;
                        list[3].data = [];
                        if (v.status === 'fulfilled') {
                            list[3].data = (v.value as DCULogData[])?.map((item, index) => ({ ...item, key: index }));
                        } else {
                            message.error(typeof v.reason === 'string' ? v.reason : Mes['messageErrorSavefailuresavefailure']);
                        }
                        break;
                    case 4:
                        list[4].colunms = EVENT_COLUMNS;
                        list[4].data = [];
                        if (v.status === 'fulfilled') {
                            list[4].data = (v.value as DcuAlarmEvent[])?.map((item) => ({ ...item, key: item.rn__ }));
                        } else {
                            message.error(typeof v.reason === 'string' ? v.reason : Mes['messageErrorSavefailuresavefailure']);
                        }
                        break;
                    default:
                        console.info('end');
                        break;
                }
            } catch (error) {
                console.error(error);
                message.error(Mes['messageErrorSavefailuresavefailure']);
            }
        });
        setTabsList(list);
    };

    const handleCancel = () => {
        setVisible(false);
    };

    // 暴露给父级调用的方法
    useImperativeHandle(cRef, () => ({
        async openModel (type: DeviceType, id: string, keyType:KeyType = 'dcuGuid') {
            try {
                setVisible(true);
                setDevicedType(type);
                setLoading(true);
                if (type === 'meter') {
                    await getMeterInfoData(type, id);
                } else if (type === 'dcu') {
                    await getDcuInfoData(type, id, keyType);
                }
                setLoading(false);
            } catch (error: any) {
                console.error(error);
                message.error(error.toString());
            }
        },
        closeModel () {
            handleCancel();
        },
    }));

    return (
        <Modal
            title={deviceTitle[devicedType]}
            visible={visible}
            width={width}
            onCancel={handleCancel}
            footer={[]}
            destroyOnClose
            focusTriggerAfterClose={false}
            className='terminalModal'>
            <Spin tip='Loading...' spinning={loading}>
                <Tabs defaultActiveKey='0'>
                    {tabsList.map((v) => (
                        <TabPane tab={v.name} key={v.key}>
                            <TerminalContent<TabsListItemData> type={v.type} data={v.data} colunms={v.colunms} Mes={Mes} />
                        </TabPane>
                    ))}
                </Tabs>
            </Spin>
        </Modal>
    );
};

export default TerminalInfo;
